export class UserCredentials {
    login: string
    password: string
}



// WEBPACK FOOTER //
// ./src/types/auth/UserCredentials.ts